<script>
import ProviderProducts from '@/components/products-table'

export default {
  name: 'ProviderProductsTab',
  components: {
    ProviderProducts,
  },
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <el-card>
    <provider-products
      :title="false"
      :products="provider.products"
      :provider="provider"
      :show-provider-id="true"
      :class="$style.products"
    />
  </el-card>
</template>

<style lang="scss" module>
.products {
  :global {
    .el-card {
      margin: 0;
    }

    .el-card__body {
      padding: 0;
    }
  }
}

</style>
